import React, { useMemo } from "react";
import { Link, withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n";
import { dedupeProjectTeam } from "./dedupeProjectTeam";

function SingleProjectInfo(props) {
  const { t } = useTranslation();
  const projeto = props.projeto;
  const fundedByDesignation = projeto?.program?.[0]?.designation?.trim() ?? "";
  const projectCode = useMemo(() => {
    const approved = projeto?.approved_project;
    if (!Array.isArray(approved)) return "";
    for (const ap of approved) {
      const code = ap?.project_code?.trim();
      if (code) return code;
    }
    return "";
  }, [projeto?.approved_project]);

  const { funderLogos, projectLogos } = useMemo(() => {
    const funder = [];
    const project = [];
    const seenFunderUrls = new Set();
    const seenProjectUrls = new Set();
    const approved = projeto?.approved_project;
    if (!Array.isArray(approved)) {
      return { funderLogos: funder, projectLogos: project };
    }
    for (const ap of approved) {
      for (const entry of ap?.files ?? []) {
        const file = entry?.file;
        const url = file?.url;
        if (!url) continue;
        const baseMime = (file.mime_type ?? "")
          .toLowerCase()
          .split(";")[0]
          .trim();
        if (!baseMime.startsWith("image/")) continue;
        const typeName = entry?.file_type?.type_name ?? "";
        if (typeName === "Barra de Logótipos") {
          if (seenFunderUrls.has(url)) continue;
          seenFunderUrls.add(url);
          funder.push({
            id: file?.id ?? url,
            url,
            alt: file?.filename?.trim() || t("Funder logo"),
          });
        }
        if (typeName === "Logótipo do Projeto") {
          if (seenProjectUrls.has(url)) continue;
          seenProjectUrls.add(url);
          project.push({
            id: file?.id ?? url,
            url,
            alt: file?.filename?.trim() || t("Logo"),
          });
        }
      }
    }
    return { funderLogos: funder, projectLogos: project };
  }, [projeto, t]);

  const coordinators = useMemo(
    () =>
      dedupeProjectTeam(projeto?.team ?? []).filter(
        (member) => member.coordination === true
      ),
    [projeto?.team]
  );

  console.log("budget", projeto.budget)

  return (
    <>
      <div className="team-inner inner-shadow">
        <div className="fig-detail text-center">
          <h3>{projeto.description}</h3>
          <p>{props.research_area}</p>
          <div>
            <b>Coordinator(s):</b>
            {coordinators.length > 0 ? (
              <ul>
                {coordinators.map((coordinator, index) => {
                  // Check if the coordinator's name has the expected format.
                  let webSiteName = coordinator.name;
                  let fullName = coordinator.name;
                  if (coordinator.name.includes(" - ")) {
                    [webSiteName, fullName] = coordinator.name.split(" - ");
                  }
                  return (
                    <li key={index}>
                      <Link
                        to={{
                          // Adjust the pathname as needed. Here I'm using the coordinator's email for uniqueness.
                          pathname: `/team-details/${webSiteName}`,
                          state: { username: webSiteName },
                        }}
                        onClick={(e) => {
                          e.preventDefault(); // Prevent React Router's navigation
                          window.location.href = `/team-details/${webSiteName}`; // Force full reload to the new URL
                        }}
                      >
                        {fullName}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <span>No coordinator found</span>
            )}
          </div>
        </div>
      </div>
      <div className="team-inner inner-shadow">
        <div className="single-item mt-md-30 personal-info">
          <div className="item-title">
            <h4>State</h4>
          </div>
          <ul>
            <li>
              <p>
                {projeto.on_going === true ? (
                  <span>Ongoing</span>
                ) : (
                  <span>Completed</span>
                )}
              </p>
            </li>
          </ul>
        </div>
        {fundedByDesignation && (
          <div className="single-item mt-md-30 personal-info">
            <div className="item-title">
              <h4>{t("Funded By")}</h4>
            </div>
            <ul>
              <li>
                <p>
                  <span>{fundedByDesignation}</span>
                </p>
              </li>
            </ul>
            {funderLogos.length > 0 && (
              <div className="funderLogosInner">
                {funderLogos.map((logo) => (
                  <img
                    key={logo.id}
                    src={logo.url}
                    alt={logo.alt}
                    className="funderLogoImg"
                    loading="lazy"
                  />
                ))}
              </div>
            )}
          </div>
        )}
        {projectCode && (
          <div className="single-item mt-md-30 personal-info">
            <div className="item-title">
              <h4>{t("Project Code")}</h4>
            </div>
            <ul>
              <li>
                <p>
                  <span>{projectCode}</span>
                </p>
              </li>
            </ul>
          </div>
        )}
        <div className="single-item mt-md-30 personal-info">
          <div className="item-title">
            <h4>Date</h4>
          </div>
          <ul>
            <li>
              <p>
                <span>
                  <b>Start Date: </b>
                  {new Date(projeto.start_date).toLocaleDateString(
                    "pt-pt"
                  )}
                </span>
              </p>
            </li>
            <br />
            <li>
              <p>
                <span>
                  <b>End Date: </b>
                  {new Date(projeto.end_date).toLocaleDateString("pt-pt")}
                </span>
              </p>
            </li>
          </ul>
        </div>
        {projeto.budget && projeto.budget != 0 ? (
          <div className="single-item mt-md-30 personal-info">
            <div className="item-title">
              <h4>Budget UNIPVC</h4>
            </div>
            <ul>
              <li>
                <p>
                  <span>
                    {parseFloat(projeto.budget).toLocaleString(
                      "pt-PT",
                      {
                        style: "currency",
                        currency: "EUR",
                      }
                    )}
                  </span>
                </p>
              </li>
            </ul>
          </div>
        ) : null}
        {projeto.overall_value && projeto.overall_value != '0' ? (
          <div className="single-item mt-md-30 personal-info">
            <div className="item-title">
              <h4>Budget Total</h4>
            </div>
            <ul>
              <li>
                <p>
                  {parseFloat(projeto.overall_value).toLocaleString(
                    "pt-PT",
                    {
                      style: "currency",
                      currency: "EUR",
                    }
                  )}
                </p>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
      {projectLogos.length > 0 && (
        <div className="team-inner inner-shadow">
          <div className="single-item mt-md-30 personal-info">
            <div className="funderLogosInner">
              {projectLogos.map((logo) => (
                <img
                  key={logo.id}
                  src={logo.url}
                  alt={logo.alt}
                  className="funderLogoImg"
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default withRouter(SingleProjectInfo);
